import BirthdayIcon from "./BirthdayIcon";
import GenderIcon from "./GenderIcon";
import BodyType from "./BodyType";
import Drinking from "./Drinking";
import EthinicityIcon from "./EthinicityIcon";
import LocationIcon from "./LocationIcon";
import Smoking from "./Smoking";
import HeightIcon from "./HeightIcon";
import Language from "./Language";
import Seeking from "./Seeking";
import Status from "./Status";
import Education from "./Education";
import CurrentPosition from "./CurrentPosition";
import UploadArrow from "./UploadArrow";
import DiamondIcon from "./DiamondIcon";
import GrantAccessIconv1 from "./GrantAccessIconv1";
import GrantAccessIconv2 from "./GrantAccessIconv2";
import GrantAccessIconv3 from "./GrantAccessIconv3";
import TickGoldIcon from "./TickGoldIcon";
import InstagramIcon from "./Instagram";

const ProfileIcons = {
  BirthdayIcon,
  GenderIcon,
  DiamondIcon,
  TickGoldIcon,
  UploadArrow,
  GrantAccessIconv1,
  GrantAccessIconv2,
  GrantAccessIconv3,
  BodyType,
  Drinking,
  EthinicityIcon,
  LocationIcon,
  Smoking,
  HeightIcon,
  Language,
  Seeking,
  Status,
  Education,
  CurrentPosition,
  InstagramIcon
};

export default ProfileIcons;
